import React, { useEffect, useState } from "react";

import { IonCard, IonCardContent, IonIcon, IonAlert } from "@ionic/react";
import { close } from "ionicons/icons";

import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import ReactPlayer from "react-player";
import "./MediaUploadCard.scss";
import {
  imagesOutline,
  videocamOutline,
  volumeMediumOutline,
} from "ionicons/icons";
import { CONSTANTS } from "../../../../../../constants";
import { ImageService } from "../../../ImageComponent/ImageComponent.service";
import _ from "lodash";
import { StreamingMedia } from "@ionic-native/streaming-media";
import { findDOMNode } from "react-dom";
import * as screenfull from "screenfull";
import { Screenfull } from "screenfull";
import { AudioService } from "../../../AudioComponent/AudioComponent.service";
import { VideoService } from "../../../VideoComponent/VideoComponent.service";
import { PhotoViewer } from "@ionic-native/photo-viewer";
import { utilService } from "../../../../../../services";
import PlayerModalPopup from "../../../../../../components/Shared/PlayerModalPopup/PlayerModalPopup";
interface MediaUploadCardParams {
  mediaItem: any;
  onCardRemove: () => void;
}

const MediaUploadCard: React.FC<MediaUploadCardParams> = (props) => {
  const [showDeleteAlert, setShowDeleteAlert]: any = useState(false);
  const [player, setPlayer]: any = useState({});
  const [isWeb, setIsWeb]: any = useState(false);
  const [showPlayerModal, setShowPlayerModal]: any = useState(false);
  const [playerPopUpModal, setPlayerPopUpModal]: any = useState(false);

  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  useEffect(() => {
    if (utilService.isWeb()) {
      setIsWeb(true);
    }
  }, []);

  if (document.addEventListener) {
    document.addEventListener("fullscreenchange", exitHandler, false);
    document.addEventListener("mozfullscreenchange", exitHandler, false);
    document.addEventListener("MSFullscreenChange", exitHandler, false);
    document.addEventListener("webkitfullscreenchange", exitHandler, false);
  }

  function exitHandler() {
    var document: any = window.document;
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setTimeout(() => {
        showpreview();
      }, 1000);
    }
  }

  const removeCurrentCardItem = (item: any) => {
    switch (item.type) {
      case 1:
        _.remove(ImageService.uploadImageList, {
          clientMediaID: item.clientMediaID,
        });
        _.remove(ImageService.displayImageList, {
          clientMediaID: item.clientMediaID,
        });
        break;
      case 2:
        _.remove(AudioService.uploadAudioList, {
          clientMediaID: item.clientMediaID,
        });
        _.remove(AudioService.displayAudioList, {
          clientMediaID: item.clientMediaID,
        });
        break;
      case 3:
        _.remove(VideoService.uploadVideoList, {
          clientMediaID: item.clientMediaID,
        });
        _.remove(VideoService.displayVideoList, {
          clientMediaID: item.clientMediaID,
        });
        break;
    }
    props.onCardRemove();
  };

  const viewItem = (type: Number) => {
    switch (type) {
      case CONSTANTS.MEDIA_TYPE.AUDIO:
        playAudio();
        break;
      case CONSTANTS.MEDIA_TYPE.VIDEO:
        viewVideo();
        break;
      case CONSTANTS.MEDIA_TYPE.IMAGE:
        viewImage();
        break;
    }
  };

  const viewImage = () => {
    if (props.mediaItem.isAttach || isWeb) {
      viewWebImage();
    } else {
      viewNativeImage();
    }
  };

  const viewVideo = () => {
    if (!isWeb) {
      viewNativeVideo();
    } else {
      preview();
    }
  };

  const viewNativeVideo = () => {
    if (props.mediaItem.isAttach) {
      setShowPlayerModal(true);
    } else {
      StreamingMedia.playVideo(props.mediaItem.nativeURL);
    }
  };

  const playAudio = () => {
    if (!isWeb) {
      playNativeAudio();
    } else {
      setPlayerPopUpModal(true);
    }
  };

  const playNativeAudio = () => {
    if (props.mediaItem.isAttach) {
      setPlayerPopUpModal(true);
    } else {
      StreamingMedia.playAudio(props.mediaItem.nativeURL);
    }
  };

  const viewWebImage = () => {
    const img: any = document.getElementById(
      `media-${props.mediaItem.clientMediaID}`
    );
    const viewer = new Viewer(img, {
      backdrop: true,
      button: false,
      toolbar: 0,
      hide() {
        viewer.destroy();
      },
    });
    viewer.show();
  };

  const viewNativeImage = () => {
    PhotoViewer.show(props.mediaItem.nativeURL, "");
  };

  const preview = () => {
    (screenfull as Screenfull).request(findDOMNode(player) as any);
  };

  const showpreview = () => {
    if (player.context) {
      // player.showPreview();
    }
  };

  const reference = (player: any) => {
    setPlayer(player);
  };

  return (
    <div
      className="media-upload-card-main-container"
      id={`media-upload-card-item-${props.mediaItem.clientMediaID}`}
    >
      <IonCard>
        <IonCardContent>
          <div
            className="media-upload-card-item"
            onClick={() => viewItem(props.mediaItem.type)}
          >
            <div className="media-upload-card-item-wrapper">
              <div className="file-share-icon-div">
                {props.mediaItem.type === 2 && (
                  <div className="audio-icon-div">
                    <IonIcon
                      icon={volumeMediumOutline}
                      className="media-icon"
                    ></IonIcon>
                  </div>
                )}
                {props.mediaItem.type === 1 && (
                  <div className="images-icon-div">
                    <IonIcon
                      icon={imagesOutline}
                      className="media-icon"
                    ></IonIcon>
                  </div>
                )}
                {props.mediaItem.type === 3 && (
                  <div className="video-icon-div">
                    <IonIcon
                      icon={videocamOutline}
                      className="media-icon"
                    ></IonIcon>
                  </div>
                )}
              </div>

              {props.mediaItem.type === 1 && props.mediaItem.isAttach && (
                <img
                  className="hide-media-image"
                  id={`media-${props.mediaItem.clientMediaID}`}
                  src={props.mediaItem.nativeURL}
                  alt="media"
                />
              )}

              {props.mediaItem.type === 3 && isWeb && (
                <ReactPlayer
                  ref={reference}
                  url={props.mediaItem.nativeURL}
                  light={false}
                  // onClickPreview={preview}
                  controls={true}
                  width={0}
                  height={0}
                />
              )}

              <div className="media-details-div">
                <div className="media-details-name">{props.mediaItem.name}</div>
                <div className="media-details-message">
                  {props.mediaItem.size} MB
                </div>
              </div>
              <div className="media-options-div">
                <div
                  className="icon-close"
                  onClick={(e: any) => {
                    e.stopPropagation();
                    e.persist();
                    setShowDeleteAlert(true);
                  }}
                ></div>
              </div>
            </div>
          </div>
        </IonCardContent>
      </IonCard>

      <PlayerModalPopup
        showModal={showPlayerModal}
        onOk={() => {
          setShowPlayerModal(false);
        }}
        url={props.mediaItem.nativeURL}
        type={props.mediaItem.type}
        onCancel={() => {
          setShowPlayerModal(false);
        }}
      />

      <IonAlert
        isOpen={showDeleteAlert}
        onDidDismiss={() => setShowDeleteAlert(false)}
        cssClass="media-list-delete-alert"
        header="Confirmation Message"
        message="Are you sure you want to delete this media?"
        buttons={[
          {
            text: "NO",
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: "YES",
            handler: () => {
              setShowPopover({ showPopover: false, event: undefined });
              removeCurrentCardItem(props.mediaItem);
            },
          },
        ]}
      />

      {props.mediaItem.type === 2 && playerPopUpModal && (
        <div className="audio-player-div">
          <div
            className="close-icon"
            onClick={() => {
              setPlayerPopUpModal(false);
            }}
          >
            <IonIcon icon={close}></IonIcon>
          </div>
          <audio autoPlay controls controlsList="nodownload">
            <source src={props.mediaItem.nativeURL} />
            Your browser does not support the audio element.
          </audio>
        </div>
      )}
    </div>
  );
};

export default MediaUploadCard;
